<template>
  <div>
    <div class="col-mr-5 mt-3">
      <right-panel class="float-right" id="sidebar-new-electronic-storage" width="800px" :icon="'mdi mdi-plus'" :text="$t('electronic-storage.new')">
        <div class="pl-5 pr-5">
          <FormElectronicStorage @onFormSave="onStorageSelect" :inventory="true" :hide-library="true" />
        </div>
      </right-panel>
    </div>
    <h6>{{ $t("electronic-storage.text") }}</h6>

    <filter-select
      id="storageFilter"
      ref="storageFilter"
      :placeholder="$t('electronic-storage.text')"
      :multiple="true"
      :max="5"
      @filter="onStorageSearch"
      :selected="form.libraryItem"
      @changed="onStorageSelect"
    />

    <div class="mt-3">
      <sweet-input
        :isValid="true"
        @input="$v.form.since.$touch()"
        v-model="form.since"
        layout="vertical"
        :placeholder="$t('electronic-storage.since')"
        :label="$t('electronic-storage.since')"
      />
    </div>

    <b-row class="mt-3">
      <b-col>
        <sweet-input
          :isValid="!$v.form.period.$error"
          @input="$v.form.period.$touch()"
          v-model="form.period"
          type="number"
          layout="vertical"
          :placeholder="$t('electronic-storage.period')"
          :label="$t('electronic-storage.period')"
        />
      </b-col>
      <b-col>
        <h6>{{ $t("common.unit") }}</h6>
        <select v-model="unit" class="form-control form-control">
          <option value="year">{{ $t("common.year") }}</option>
          <option value="month">{{ $t("common.month") }}</option>
        </select>
      </b-col>
    </b-row>

    <div class="mt-3">
      <sweet-input
        :isValid="true"
        @input="$v.form.legalBasis.$touch()"
        v-model="form.legalBasis"
        layout="vertical"
        :placeholder="$t('electronic-storage.legal-basis')"
        :label="$t('electronic-storage.legal-basis')"
      />
    </div>

    <div class="mt-3">
      <sweet-input :isValid="true" v-model="form.description" layout="vertical" :placeholder="$t('common.description')" :label="$t('common.description')" />
    </div>

    <sweet-button @click="save()" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>

    <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
      {{ $t("common.cancel") }}
    </sweet-button>

    <storage-period-recommendation @onApply="applyRecommendation" />
  </div>
</template>

<script>
import FormElectronicStorage from "@modules/storage-environments/electronic-storage/workspace-library-electronic-storage-form";
import { required } from "vuelidate/lib/validators";
import StoragePeriodRecommendation from "../recommendation/storage/storage-period-recommendation.vue";

export default {
  props: ["prepareMode", "id"],
  components: { FormElectronicStorage, StoragePeriodRecommendation },
  validations: {
    form: {
      libraryItem: {
        required,
      },
      period: {
        required,
      },
      since: {},
    },
  },
  data() {
    return {
      form: { libraryItem: undefined, period: 1, since: undefined, legalBasis: undefined, description: undefined },
      unit: "year",
    };
  },

  computed: {
    isUpdating() {
      return this.$store.getters["datasourceElectronicStorage/isUpdating"];
    },
    editedDatasource() {
      return this.$store.getters["datasourceElectronicStorage/editedDatasource"];
    },
    editedElectronicStorage() {
      return this.$store.getters["datasourceElectronicStorage/editedElectronicStorage"];
    },
  },
  watch: {
    editedElectronicStorage: {
      deep: true,
      immediate: true,
      handler(v) {
        this.unit = "month";

        if (v) {
          this.form = { ...v };
        }
        this.form.libraryItem = v?.libraryItem ? [v.libraryItem] : [];
      },
    },
  },
  mounted() {},
  methods: {
    applyRecommendation(recommendation) {
      let period = recommendation.period;
      this.unit = "month";
      if (recommendation.period % 12 == 0) {
        period = recommendation.period / 12;
        this.unit = "year";
      }

      this.form = {
        ...this.form,
        period: period,
        since: recommendation.since,
        legalBasis: recommendation.legalBasis,
      };
    },

    cancel() {
      this.$store.dispatch("datasourceElectronicStorage/resetForm");
      this.$root.$emit("bv::toggle::collapse", this.id);
    },
    async save() {
      if (!this.prepareMode) {
        const ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
      }

      try {
        this.form.datasource = this.editedDatasource;

        let period = this.form.period;
        if (this.unit == "year") {
          period = period * 12;
        }

        if (this.prepareMode) {
          if (this.editedElectronicStorage?.libraryItem) {
            this.$store.commit("gdprInventoryBulkUpdate/removeElectronicStorage", this.editedElectronicStorage);
          }

          this.$emit("onSaved", { ...this.form, period });
        } else {
          for (const item of this.form.libraryItem) {
            try {
              await this.$store.dispatch("datasourceElectronicStorage/save", { ...this.form, libraryItem: item, period });
              this.$toast.success(this.$t("common.success"));
            } catch (error) {
              this.$handleHttpErrorByStatusCode(error);
            }
          }
        }

        this.form = { libraryItem: undefined, period: 1, since: undefined, legalBasis: undefined, description: undefined };
        this.$root.$emit("bv::toggle::collapse", this.id);
        this.$store.commit("datasourceElectronicStorage/editedElectronicStorage", null);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async onStorageSearch(value, callback) {
      const response = await this.$store.dispatch(`electronicStorage/paginate`, {
        options: { limit: 1000 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },
    onStorageSelect(item) {
      this.form = { ...this.form, libraryItem: item };
    },
  },
};
</script>
